import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import BackButton from '../components/BackButton'
import HeaderDashboardByVehicle from '../components/HeaderDashboardByVehicle'
import HorizontalEventMenuByVehicle from '../components/HorizontalEventMenuByVehicle'
import EventContentByVehicle from '../components/EventContentByVehicle'
import Time from '../components/Time'
import backIcon from '../images/backIcon.svg'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'
import { Query } from 'react-apollo'
import { OFFENSE_OF_CURRENT_DAY_BY_VEHICLE } from '../query/event'
import CircularProgress from '@material-ui/core/CircularProgress'

class OffenseByVehicleComponent extends React.Component {
  constructor () {
    super()
    this._isMounted = false
    this.state = {
      tokenIsValide: false
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token'))
          }
          self.setState({
            tokenIsValide: true
          })
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  backToList () {
    console.log("BACK TO LIST")
  }

  render () {
    let d = new Date()
    d.setHours(0, 0, 0, 0)
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu />
              </td>
              <td style={styles.content}>
                <BackButton
                  link='all-report'
                  label='LISTE'
                  img={backIcon}
                  onClick={() => this.backToList()}
                />
                <HeaderDashboardByVehicle
                  vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  enabled='event'
                />
                <HorizontalEventMenuByVehicle
                  vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  enabled='offense'
                />
                { this.state.tokenIsValide
                  ? <Query
                    query={OFFENSE_OF_CURRENT_DAY_BY_VEHICLE}
                    variables={{ occurred_at: d, jsonFilter: { 'trb_imm': this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber') } }}
                  >
                    {({ data, loading, error, subscribeToMore }) => {
                      if (!data) {
                        return null
                      }
                      if (error) {
                        return <p>{error.message}</p>
                      }

                      if (loading) {
                        return <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
                      }

                      return (
                        <EventContentByVehicle
                          route='OffenseByVehicle'
                          events={data.events}
                          vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                          subscribeToMore={subscribeToMore}
                        />
                      )
                    }}
                  </Query>
                  : <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
                }
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  }
}

export default OffenseByVehicleComponent
